import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import API_URL from './api/config';


function ForgotPasswordVerify() {
    const [values, setValues] = useState({ verify_code: '' });
    const navigate = useNavigate(); 

    

    const [digits, setDigits] = useState(['', '', '', '', '', '']);
    const [loading, setLoading] = useState(false);
    const [timeLeft, setTimeLeft] = useState(600); // 10 minutes
    const inputRefs = useRef([]); 
    axios.defaults.withCredentials = true;
   
    // ── Countdown timer ──────────────────────────────────────────
    useEffect(() => {
      if (timeLeft <= 0) return;
      const tick = setInterval(() => setTimeLeft((t) => t - 1), 1000);
      return () => clearInterval(tick);
    }, [timeLeft]);
   
    
   
    // ── OTP input handlers ───────────────────────────────────────
    const handleDigitChange = (index, value) => {
      const cleaned = value.replace(/[^0-9]/g, '').slice(-1);
      const updated = [...digits];
      updated[index] = cleaned;
      setDigits(updated);
      if (cleaned && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    };
   
    const handleKeyDown = (index, e) => {
      if (e.key === 'Backspace' && !digits[index] && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    };
   
    const handlePaste = (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, 6);
      const updated = [...digits];
      pasted.split('').forEach((char, i) => { updated[i] = char; });
      setDigits(updated);
      const nextEmpty = updated.findIndex((d) => !d);
      inputRefs.current[nextEmpty === -1 ? 5 : nextEmpty]?.focus();
    };
   
    const handleResend = () => {
      setDigits(['', '', '', '', '', '']);
      setTimeLeft(600);
      inputRefs.current[0]?.focus();
      toast.info('A new code has been sent to your email.', { position: 'top-right', autoClose: 3000 });
      // TODO: call your resend code API here
    };
   
    // ── Form submit ──────────────────────────────────────────────
    const handleForgotPassword = async (e) => {
      e.preventDefault();
      const verify_code = digits.join('');
      if (verify_code.length < 6) {
        toast.error('Please enter the complete 6-digit code.', { position: 'top-right', autoClose: 3000 });
        return;
      }
      setLoading(true);
      try {
        const res = await axios.post(`${API_URL}/forgot-password-verify-api`, { verify_code });
        if (res.data.Status === 'Success') {
          localStorage.setItem('verify_code', res.data.verify_code);
          toast.success('Code verified!', { position: 'top-right', autoClose: 3000 });
          navigate(res.data.redirect);
        } else {
          toast.error(res.data.Message, { position: 'top-right', autoClose: 3000 });
        }
      } catch (err) {
        toast.error(err.message || 'Something went wrong', { position: 'top-right', autoClose: 3000 });
      } finally {
        setLoading(false);
      }
    };
   
    // ── Shared input box style ───────────────────────────────────
    const boxStyle = (filled) => ({
      width: '52px',
      height: '58px',
      textAlign: 'center',
      fontSize: '1.4rem',
      fontWeight: '600',
      border: `2px solid ${filled ? '#0d6e28' : '#ced4da'}`,
      borderRadius: '12px',
      outline: 'none',
      color: '#0d6e28',
      transition: 'border-color 0.2s, box-shadow 0.2s',
      background: '#fff',
    });

    
  

      
    return (
        <div
        style={{
          background: 'linear-gradient(135deg, #f4f7f5 0%, #e8f0ea 100%)',
          fontFamily: "'DM Sans', sans-serif",
          padding: '1rem',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ToastContainer />
        <div style={{ width: '100%', maxWidth: '520px', margin: 'auto' }}>
          <div
            style={{
              background: '#ffffff',
              borderRadius: '24px',
              overflow: 'hidden',
              boxShadow: '0 20px 40px -12px rgba(0,0,0,0.25)',
              animation: 'fadeInUp 0.5s ease-out',
            }}
          >
            {/* ── Header ── */}
            <div
              style={{
                background: 'linear-gradient(135deg, #0d6e28 0%, #0a5520 100%)',
                padding: '1.5rem 1.5rem 1rem',
                textAlign: 'center',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.75rem' }}>
                <div
                  style={{
                    width: '60px',
                    height: '60px',
                    background: 'rgba(255,255,255,0.15)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    animation: 'float 3s ease-in-out infinite',
                  }}
                >
                  <i className="fas fa-shield-alt" style={{ fontSize: '28px', color: 'white' }}></i>
                </div>
              </div>
              <h3 style={{ color: 'white', margin: '0.5rem 0 0.25rem', fontSize: '1.3rem', fontWeight: '600' }}>
                Verify Your Code
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.75rem', marginBottom: 0 }}>
                Enter the verification code sent to your email
              </p>
            </div>
   
            {/* ── Body ── */}
            <div style={{ padding: '1.5rem 1.25rem 1.25rem' }}>
              <form onSubmit={handleForgotPassword}>
   
                {/* Info banner */}
                <div
                  style={{
                    background: '#f0faf3',
                    borderLeft: '3px solid #0d6e28',
                    borderRadius: '8px',
                    padding: '0.75rem',
                    marginBottom: '1.25rem',
                  }}
                >
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <span style={{ fontSize: '1rem' }}>📩</span>
                    <p style={{ margin: 0, color: '#1a4a2a', fontSize: '0.78rem', fontWeight: '500' }}>
                      We sent a 6-digit code to your email. Use it to verify.
                    </p>
                  </div>
                </div>
   
                {/* OTP boxes */}
                <div style={{ marginBottom: '1.25rem' }}>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      color: '#444',
                      marginBottom: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      textAlign: 'center',
                    }}
                  >
                    Enter Verification Code
                  </label>
                  
                  <div
  style={{
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px',
    margin: '0 auto'
  }}
>
  {digits.map((digit, i) => (
    <React.Fragment key={i}>
      {i === 3 && (
        <span
          style={{
            color: '#ccc',
            fontSize: '1.5rem',
            fontWeight: '300'
          }}
        >
          ·
        </span>
      )}

      <input
        ref={(el) => (inputRefs.current[i] = el)}
        type="text"
        inputMode="numeric"
        maxLength={1}
        value={digit}
        onChange={(e) => handleDigitChange(i, e.target.value)}
        onKeyDown={(e) => handleKeyDown(i, e)}
        onPaste={i === 0 ? handlePaste : undefined}
        style={{
          flex: 1,
          minWidth: '35px',
          maxWidth: '45px',
          height: '50px',
          textAlign: 'center',
          fontSize: '1.2rem',
          border: '1px solid #ced4da',
          borderRadius: '8px'
        }}
      />
    </React.Fragment>
  ))}
</div>
                </div>
   
                {/* Countdown timer */}
                 
   
                {/* Verify button */}
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: '100%',
                    background: loading ? '#c0cfc5' : '#0d6e28',
                    border: 'none',
                    borderRadius: '40px',
                    padding: '0.7rem',
                    fontWeight: '600',
                    fontSize: '0.85rem',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    color: '#ffffff',
                    marginBottom: '0.75rem',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => { if (!loading) e.target.style.background = '#0a5520'; }}
                  onMouseLeave={(e) => { if (!loading) e.target.style.background = '#0d6e28'; }}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        style={{ width: '0.8rem', height: '0.8rem' }}
                      ></span>
                      Verifying...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-shield-alt me-2"></i>
                      Verify Code
                    </>
                  )}
                </button>
   
                {/* Resend button */}

                <button
                type="button"
                onClick={() => navigate('/forgot-password')}
                style={{
                  width: '100%',
                  padding: '0.7rem',
                  backgroundColor: 'transparent',
                  color: '#0d6e28',
                  border: '1.5px solid #0d6e28',
                  borderRadius: '40px',
                  fontSize: '0.85rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  marginBottom: '0.75rem',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#0d6e28';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#0d6e28';
                }}
              >
                <i className="fas fa-redo me-2"></i>
                Resend Code
              </button>

                
   
                {/* Already have account */}
                <div style={{ background: '#f8fcf9', borderRadius: '8px', padding: '0.5rem', textAlign: 'center' }}>
                  <p style={{ fontSize: '0.65rem', color: '#999', margin: 0 }}>
                    <i className="fas fa-user" style={{ marginRight: '5px' }}></i>
                    Already have an account?{' '}
                    <Link to="/login" style={{ color: '#0d6e28', textDecoration: 'none', fontWeight: '600' }}>
                      Login here
                    </Link>
                  </p>
                </div>
   
              </form>
            </div>
   
            {/* ── Footer ── */}
            <div
              style={{
                borderTop: '1px solid #e5ede8',
                padding: '0.6rem',
                background: '#fafdfb',
                textAlign: 'center',
              }}
            >
              <p style={{ fontSize: '0.6rem', color: '#8aa899', margin: 0 }}>
                <i className="fas fa-headset me-1"></i>
                Need help? Contact support@oret.africa
              </p>
            </div>
          </div>
        </div>
   
        <style>{`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(20px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          @keyframes float {
            0%, 100% { transform: translateY(0); }
            50%       { transform: translateY(-5px); }
          }
        `}</style>
      </div>
  

    );
}

export default ForgotPasswordVerify;
